
export function initCodeArea(selector) {
	$(selector).addClass("mono").on("keydown", keyDown);
}

function keyDown(e) {
	let keyCode = e.keyCode || e.which;

	if (keyCode === 9) {
		e.preventDefault();
		let start = this.selectionStart;
		let end = this.selectionEnd;

		// set textarea value to: text before caret + tab + text after caret
		let area = $(this);
		let val = area.val();
		area.val(val.substring(0, start) + "\t" + val.substring(end));

		// put caret at right position again
		this.selectionStart = this.selectionEnd = start + 1;
	} else if (keyCode === 13) {
		e.preventDefault();
		let start = this.selectionStart;
		let end = this.selectionEnd;

		// set textarea value to: text before caret + tab + text after caret
		let area = $(this);
		let val = area.val();

		let p = wsPrefix(val, start);

		area.val(val.substring(0, start) + "\n" + p + val.substring(end));

		// put caret at right position again
		this.selectionStart = this.selectionEnd = start + p.length + 1;

	}
}

function currentLineIndent(text, cursorAt) {
	let p = wsPrefix(text, cursorAt);
}

/**
 * @param {string} text
 * @param {number} cursorAt
 */
function wsPrefix(text, cursorAt) {
	let nws = seekToNonWhitespace(text, cursorAt);
	let lineStart = seekToLineStart(text, nws);
	if (lineStart < nws) {
		let endOfWS = seekToNonWhitespaceForward(text, lineStart);
		return text.substring(lineStart, endOfWS);
	}
	return "";
}

function seekToNonWhitespace(text, pos) {
	for (let idx = pos; idx >= 0; idx--) {
		let ch = text.charAt(idx);
		if (!/\s/.test(ch)) return idx;
	}
	return -1;
}

function seekToNonWhitespaceForward(text, pos) {
	for (let idx = pos; idx < text.length; idx++) {
		let ch = text.charAt(idx);
		if (!/\s/.test(ch)) return idx;
	}
	return text.length;
}


function seekToLineStart(text, pos) {
	let idx;
	for (idx = pos; idx >= 0; idx--) {
		let ch = text.charAt(idx);
		if (ch === "\n" || ch === "\r") return idx+1;
	}
	return 0;
}